import { createAsyncAtom } from '../../lib';
import { lendAndBorrowAdjustStatusAtom } from './lendAndBorrowAdjust';
import { lendAndBorrowBorrowStatusAtom } from './lendAndBorrowBorrowAtom';
import { lendAndBorrowDepositStatusAtom } from './lendAndBorrowDepositAtom';
import { lendAndBorrowRepayStatusAtom } from './lendAndBorrowRepay';
import { lendAndBorrowWithdrawStatusAtom } from './lendAndBorrowWithdrawAtom';

const lendAndBorrowPendingTransactionAtom = createAsyncAtom(async get => {
  const depositStatus = await get(lendAndBorrowDepositStatusAtom);
  const withdrawStatus = await get(lendAndBorrowWithdrawStatusAtom);
  const borrowStatus = await get(lendAndBorrowBorrowStatusAtom);
  const repayStatus = await get(lendAndBorrowRepayStatusAtom);
  const adjustStatus = await get(lendAndBorrowAdjustStatusAtom);

  if (
    depositStatus?.pending ||
    withdrawStatus?.pending ||
    borrowStatus?.pending ||
    repayStatus?.pending ||
    adjustStatus?.pending
  ) {
    return true;
  }
  return false;
});
export default lendAndBorrowPendingTransactionAtom;
